// extracted by mini-css-extract-plugin
module.exports = {"container":"section2_container__VPJON","content":"section2_content__4v3fa"};